<template>
    <div class="form-container">
      <!-- Form -->
      <form @submit.prevent="submitForm">


        <div v-show="currentStep === 1">

          <h3>User Details</h3>
        <div class="form-group">
          <label for="user_name" class="text-start d-block">
            <i class="bi bi-person-fill"></i> First Name
          </label>
          <input type="text" v-model="form.user_name" id="user_name" class="form-control" required />
        </div>

        <div class="form-group">
          <label for="institute_name" class="text-start d-block">
            <i class="bi bi-building"></i> Last Name
          </label>
          <input type="text" v-model="form.last_name" id="last_name" class="form-control" required />
        </div>

        <div class="form-group">
          <label for="email" class="text-start d-block">
            <i class="bi bi-envelope-fill"></i> Email
          </label>
          <input type="email" v-model="form.email" class="form-control" required />
        </div>
  
        <div class="form-group">
          <label for="password" class="text-start d-block">
            <i class="bi bi-lock-fill"></i> Password
          </label>
          <div class="input-group">
            <input :type="passwordVisible ? 'text' : 'password'" v-model="form.password" id="password" class="form-control" required />
            <span class="input-group-text" @click="togglePasswordVisibility">
              <i :class="passwordVisible ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
            </span>
          </div>
        </div>
  
        <div class="form-group">
          <label for="confirm_password" class="text-start d-block">
            <i class="bi bi-lock-fill"></i> Confirm Password
          </label>
          <input :type="passwordVisible ? 'text' : 'password'" v-model="form.confirmPassword" id="confirm_password" class="form-control" required />
        </div>



        <div class="form-group">
          <label for="profile_photo" class="text-start d-block">
            <i class="bi bi-image-fill"></i> Profile Photo
          </label>
          <input type="file" @change="handleFileUpload" id="profile_photo" class="form-control" required />
        </div>

        <div class="btnClassA">
        <button @click="nextStep" class="btn btn-primary fieldClass" type="button">Next</button>
      </div>


      </div>

<div v-show="currentStep === 2">

  <h3>Teacher Details</h3>

        <div class="form-group">
          <label for="institute_name" class="text-start d-block">
            <i class="bi bi-building"></i> Teacher NIC
          </label>
          <input type="text" v-model="form.teacher_nic" class="form-control" required />
        </div>

        <div class="form-group">
          <label for="institute_name" class="text-start d-block">
            <i class="bi bi-building"></i> Birth Day
          </label>
          <input type="date" v-model="form.birth_day" class="form-control" required />
        </div>
  
        <div class="form-group">
          <label for="address" class="text-start d-block">
            <i class="bi bi-geo-alt-fill"></i> Address
          </label>
          <input type="text" v-model="form.address" class="form-control" required />
        </div>
  
        <div class="form-group">
          <label for="contact" class="text-start d-block">
            <i class="bi bi-telephone-fill"></i> Contact
          </label>
          <input type="text" v-model="form.contact" class="form-control" required />
        </div>
  

        <div class="btnClassA">
        <button @click="prevStep" class="btn btn-secondary fieldClass" type="button">Prev</button>
        <button @click="nextStep" class="btn btn-primary fieldClass" type="button">Next</button>
      </div>


      </div>

<div v-show="currentStep === 3">
  <h3>Item Details</h3>

        <div class="form-group">
          <label for="institute" class="text-start d-block">
            <i class="bi bi-geo-alt-fill"></i> Select Institute
          </label>
          <select v-model="selectedInstituteId" class="form-control" required>
            <option v-for="institute in institutes" :key="institute.id" :value="institute.id">
              {{ institute.institute_name }}
            </option>
          </select>
        </div>
  
        <div class="form-group">
          <label for="subject" class="text-start d-block">
            <i class="bi bi-geo-alt-fill"></i>Select Subject
          </label>
          <select v-model="selectedSubjectId" class="form-control" required>
            <option v-for="subject in subjects" :key="subject.id" :value="subject.id">
              {{ subject.name }} = {{ subject.subject_price }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="studentLevel" class="text-start d-block">
            <i class="bi bi-geo-alt-fill"></i>Select Student Level
          </label>
          <select v-model="selectedStudentLevelId" id="studentLevel" class="form-control" required>
            <option v-for="studentLevel in studentLevels" :key="studentLevel.id" :value="studentLevel.id">
              {{ studentLevel.level }} = {{ studentLevel.st_level_price }}
            </option>
          </select>
        </div>


        <h3>Accout Details</h3>

        <div class="form-group">
          <label for="pkg" class="text-start d-block">
            <i class="bi bi-geo-alt-fill"></i>Select Package
          </label>
          <select v-model="selectedPackageId" id="package" class="form-control" required>
            <option value="disabled" disabled>Packeg = Package Price = Price For Month = Pakcage Duration</option>
            <option v-for="pkg in packages" :key="pkg.id" :value="pkg.id" class="selectpackage">
              {{ pkg.type }} = {{ pkg.package_price }} = {{ pkg.pkg_price_for_month }} = {{ pkg.duration }} Month
            </option>
          </select>
        </div>

        <div class="btnClassA">
        <button @click="prevStep" class="btn btn-secondary fieldClass" type="button">Prev</button>
        <button @click="nextStep" class="btn btn-primary fieldClass" type="button">Next</button>
      </div>


      </div>

<div v-show="currentStep === 4">

  

    <div v-if="selectedSubject">
      <h3>Selected Subject Details</h3>
      <div class="package-details">
        <label><strong>Subject Name:</strong> {{ selectedSubject.name }}</label><br>
        <label><strong>Price:</strong> {{ selectedSubject.subject_price }}</label><br>
      </div>
    </div>

    <div v-if="selectedStudentLevel">
      <h3>Selected Student Level Details</h3>
      <div class="package-details">
        <label><strong>Level:</strong> {{ selectedStudentLevel.level }}</label><br>
        <label><strong>Price:</strong> {{ selectedStudentLevel.st_level_price }}</label><br>
      </div>
    </div>
  
            <!-- Selected Package Details -->
    <div v-if="selectedPackage">
      <h3>Selected Package Details</h3>
      <div class="package-details">
        <label><strong>Type:</strong> {{ selectedPackage.type }}</label><br>
        <label><strong>Duration:</strong> {{ selectedPackage.duration }}Month</label><br>
        <label><strong>Price For Month:</strong> {{ selectedPackage.pkg_price_for_month }}</label><br>
        <label><strong>Price:</strong> {{ selectedPackage.package_price }}</label><br>
      </div>
    </div>


        <!-- Subject, Student Level, and Package Selection -->
    <div v-if="selectedSubject && selectedStudentLevel">
      <div class="package-details">
        <h2>Total Selected</h2>
        <p><strong>Subject:</strong> {{ selectedSubject.subject_name }} - {{ selectedSubject.subject_price }}</p>
        <p><strong>Student Level:</strong> {{ selectedStudentLevel.level_name }} - {{ selectedStudentLevel.st_level_price }}</p>
        <!-- <p><strong>Package:</strong> {{ selectedPackage.package_name }} - {{ selectedPackage.package_price }}</p> -->
      </div>

      <!-- Total Price Calculation -->
      <p><strong>Item Total Price:</strong> {{ itemTotalPrice }}</p>
      <p><strong>PKG Total Price:</strong> {{ pkgTotalPrice }}</p>
    </div>



  
            <!-- Success Message -->
      <div v-if="successMessage" class="alert alert-success">
        <i class="bi bi-check-circle-fill"></i> {{ successMessage }}
      </div>
  
      <!-- Error Message -->
      <div v-if="errorMessage" class="alert alert-danger">
        <i class="bi bi-exclamation-circle-fill"></i> {{ errorMessage }}
      </div>
  
  
        <!-- <button type="submit" class="btn btn-primary">
          <i class="bi bi-send-fill"></i> Submit
        </button> -->


        <div class="btnClassA">
        <button type="button" @click="prevStep" class="btn btn-secondary fieldClass">Prev</button>
        <button 
  type="submit" 
  class="btn btn-primary fieldClass" 
  :disabled="loading">
  <i v-if="loading" class="bi bi-arrow-repeat spinner-border spinner-border-sm"></i> 
  <span v-if="loading">Submitting...</span>
  <span v-else>Submit</span>
</button>

      </div>

      </div>
  
      </form>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    data() {
      return {
        currentStep: 1,
        form: {
          user_name: '',
          last_name: '',
          email: '',
          password: '',
          confirmPassword: '',
          profile_photo: null,
          teacher_nic: '',
          birth_day: '',
          address: '',
          contact: '',
          institute: '',
          subject: '',
          studentLevel: '',
          pkg: '',
        },
        packages: [],
        selectedPackageId: null,
        // selectedPackage: null,

        subjects: [],
        selectedSubjectId: null,
        // selectedSubject: null,

        studentLevels:[],
        selectedStudentLevelId: null,
        // selectedStudentLevel: null,

        institutes: [],
        selectedInstituteId: null, // Define the property
        errorMessage: '', // To display error messages
        successMessage: '', // To display success messages
        passwordVisible: false, // To toggle password visibility
        loading: false,  // <-- Add this
      };
    },

    computed: {
    selectedSubject() {
      return this.subjects.find((subject) => subject.id === this.selectedSubjectId);
    },
    selectedStudentLevel() {
      return this.studentLevels.find((studentLevel) => studentLevel.id === this.selectedStudentLevelId);
    },
    selectedPackage() {
      return this.packages.find((pkg) => pkg.id === this.selectedPackageId);
    },
    itemTotalPrice() {
    const subjectPrice = this.selectedSubject ? parseFloat(this.selectedSubject.subject_price) : 0;
    const studentLevelPrice = this.selectedStudentLevel ? parseFloat(this.selectedStudentLevel.st_level_price) : 0;
    return subjectPrice + studentLevelPrice;
  },

  pkgTotalPrice() {
    const subjectPrice = this.selectedSubject ? parseFloat(this.selectedSubject.subject_price) : 0;
    const studentLevelPrice = this.selectedStudentLevel ? parseFloat(this.selectedStudentLevel.st_level_price) : 0;
    const packagePrice = this.selectedPackage ? parseFloat(this.selectedPackage.package_price) : 0;
    const packageDuration = this.selectedPackage && !isNaN(parseFloat(this.selectedPackage.duration)) ? parseFloat(this.selectedPackage.duration) : 0;

    return subjectPrice * packageDuration + studentLevelPrice * packageDuration + packagePrice;
  }

  },

    methods: {
      nextStep() {
      if (this.currentStep < 4) {
        this.currentStep++;
      }
    },

    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
      togglePasswordVisibility() {
        this.passwordVisible = !this.passwordVisible;
      },
      async submitForm() {
        if (this.form.password !== this.form.confirmPassword) {
          this.errorMessage = 'Passwords do not match.';
          return;
        }

        // Set loading to true before starting the request
        this.loading = true;
  
        const formData = new FormData();
        formData.append('first_name', this.form.user_name);
        formData.append('last_name', this.form.last_name);
        formData.append('email', this.form.email);
        formData.append('password', this.form.password);
        formData.append('confirmPassword', this.form.confirmPassword);
        formData.append('profile_photo', this.form.profile_photo);
        formData.append('teacher_nic', this.form.teacher_nic);
        formData.append('birth_day', this.form.birth_day);
        formData.append('address', this.form.address);
        formData.append('contact', this.form.contact);
        
        // Append selected ids for institute, subject, student level, and package
        formData.append('institute', this.selectedInstituteId);
        formData.append('subject', this.selectedSubjectId);
        formData.append('studentLevel', this.selectedStudentLevelId);
        formData.append('pkg', this.selectedPackageId);
        
        // Append total price
        formData.append('itemTotalPrice', this.itemTotalPrice);
        formData.append('pkgTotalPrice', this.pkgTotalPrice);
  
        try {
          const response = await axios.post('/teacher-register', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
  
          // Check if the response contains success or error
          if (response.data.success) {
            this.successMessage = response.data.success;
            this.errorMessage = ''; // Clear error message if any
          }
        } catch (error) {
          if (error.response && error.response.data.error) {
            this.errorMessage = error.response.data.error;
            this.successMessage = ''; // Clear success message if any
          } else {
            this.errorMessage = 'An unexpected error occurred.';
            this.successMessage = '';
          }
        }
        finally {
          // Set loading to false after the request is completed
          this.loading = false;
        }

        console.log('Form submitted!');
        // Emit the event to notify the parent component
        this.$emit('teacherAdded');


      },
      handleFileUpload(event) {
        this.form.profile_photo = event.target.files[0];
      },
      async fetchSubjects() {
        try {
          const response = await axios.get('/get-all-subjects');
          this.subjects = response.data;
        } catch (error) {
          this.errorMessage = 'Error fetching subjects.';
        }
      },

      async fetchInstitutes() {
        try {
          const response = await axios.get('/get-all-institutes');
          this.institutes = response.data;
        } catch (error) {
          this.errorMessage = 'Error fetching institutes.';
        }
      },

      async fetchStudentLevels() {
        try {
          const response = await axios.get('/get-all-student-levels');
          this.studentLevels = response.data;
        } catch (error) {
          this.errorMessage = 'Error fetching student level.';
        }
      },

      async fetchPackages() {
        try {
          const response = await axios.get('/get-all-packages');
          this.packages = response.data;
        } catch (error) {
          this.errorMessage = 'Error fetching package.';
        }
      }
    },
    created() {
      this.fetchSubjects();
      this.fetchInstitutes();
      this.fetchStudentLevels();
      this.fetchPackages();
    },
  };
  </script>
  
  
  <style scoped>
  .alert {
    margin-bottom: 20px;
  }
  .form-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  .text-start {
    text-align: left;
  }
  .form-group label i {
    margin-right: 5px;
  }
  .input-group {
    display: flex;
    align-items: center;
  }
  .input-group-text {
    cursor: pointer;
  }

  </style>
  
  